import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Grid, Header } from 'semantic-ui-react'
import DelivereeReportActions from '../../reducers/delivereeReportReducer'

import DateRangeField from './components/DateRangeField'

class DelivereeReport extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('day')
        .format('x')
    ),
  }

  getOrderByDate = () => {
    const { getDelivereeReport } = this.props
    const { startFrom, endAt } = this.state

    getDelivereeReport(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  render() {
    const { startFrom, endAt } = this.state
    const { loading, delivereeReport } = this.props
    const { delivereeCount, payingDelivereeCount } = delivereeReport
    const payingCustomerRate = parseFloat((payingDelivereeCount / delivereeCount) * 100 || 0).toFixed(2)

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />

          <Grid columns="equal" style={{ marginTop: 15 }}>
            <Grid.Column>
              <Segment textAlign="center">
                <Header size="medium">New Customer</Header>
                <Header size="medium">{delivereeCount || 0}</Header>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment textAlign="center">
                <Header size="medium">Paying Customer</Header>
                <Header size="medium">{payingDelivereeCount || 0}</Header>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment textAlign="center">
                <Header size="medium">Paying Customer Rate</Header>
                <Header size="medium">{payingCustomerRate} %</Header>
              </Segment>
            </Grid.Column>
          </Grid>
        </div>
      </Segment>
    )
  }
}

const mapState = ({ delivereeReport }) => ({
  delivereeReport: delivereeReport.data,
  loading: delivereeReport.loading,
})

const mapDispatch = {
  getDelivereeReport: DelivereeReportActions.getDelivereeReport,
}

export default connect(
  mapState,
  mapDispatch
)(DelivereeReport)



// WEBPACK FOOTER //
// ./src/containers/reports/customer.js